var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"bg-danger",staticStyle:{"margin-top":"69.75px !important"}}),(_vm.banner != '')?_c('img',{attrs:{"width":"100%","src":_vm.url+_vm.banner,"alt":""}}):_vm._e(),_c('Product',{attrs:{"products":_vm.products}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }